// const baseUrl = 'http://192.168.150.192:8008'
// process.env.NODE_ENV 等于 development 或 production
const productionUrl = window.baseUrl
var url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:1550/api' : productionUrl

const baseUrl = url
export default {
  baseUrl: baseUrl,

  // gz_company
  toggleCompany: baseUrl + '/gz_company/toggle_company',

  // cam_dev
  queryCamDevList: baseUrl + '/cam_dev/query_list',
  queryCamDevAllList: baseUrl + '/cam_dev/query_all_list',

  // cam_image
  queryCamImageList: baseUrl + '/cam_image/query_list',
  getCamImageByCurDate: baseUrl + '/cam_image/get_cam_image_by_cur_date',
  getRefreshCamImage: baseUrl + '/cam_image/get_refresh_cam_image',
  getCamImageDetail: baseUrl + '/cam_image/get_cam_image_detail',
  statCamImageCount: baseUrl + '/cam_image/stat_cam_image_count',

  // hh_user
  createUserInvite: baseUrl + '/hh_user/create_user_invite',
  getUserInvite: baseUrl + '/hh_user/get_user_invite',
  joinUser: baseUrl + '/hh_user/join_user',

  // hh_user_staff
  getUserStaffList: baseUrl + '/hh_user_staff/get_list',
  toggleUser: baseUrl + '/hh_user_staff/toggle_user',

  // cam_image_stats
  statTotalByTimeSpan: baseUrl + '/cam_image_stats/stat_total_by_timespan',
  stat7DayCamImage: baseUrl + '/cam_image_stats/stat_7_day_cam_image',

  // car_speed_ab
  getCarSpeedABDetail: baseUrl + '/car_speed_ab/get_detail'


}
